/**
 * CWSN Infrastructure category config
 *
 * KPIs: floorInBuilding, rampInGroundFloor, rampInAllFloor,
 *       toiletForBoys, toiletForGirl
 */
import type { CategoryConfig } from './CategoryConfig';

export const cwsnInfraConfig: CategoryConfig = {
  categoryKey: 'cwsnInfraProfile',
  label: 'CWSN Infrastructure',
  priority: 4,

  columns: {
    defaultVisibleColumns: [
      'schoolName', 'stateName', 'roName',
      'floorInBuilding', 'rampInGroundFloor', 'rampInAllFloor',
      'toiletForBoys', 'toiletForGirl',
    ],
  },
};
